import React from 'react';
import { noop } from "@client/shared/constants";
import WarningView from "./view";

const Warning = ({
  open = false,
  warningMessage = '',
  onClose = noop
}) => {
  return <WarningView
    isOpen={open}
    warningMessage={warningMessage}
    onClose={onClose}
  />;
};

export default Warning;
